/* eslint-disable */
import React, { useState, Suspense, useEffect, useContext, useCallback, useRef } from "react";
import "./group.css";
import { Paper, TextField, Button, InputAdornment, Checkbox, MenuItem, Select } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import SendIcon from "@material-ui/icons/Send";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import IconButton from "@mui/material/IconButton";
import SnackbarAPICall from "../../../shared/snackbar/SnackbarAPICall";
import CustomizedSwitches from "../../../shared/switchButton/SwitchButton";
import { AuthContext, UIContext } from "../../../../contexts";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import { api } from "../../../../utils/api";
import {
	Grid,
	Box,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	InputLabel,
	Typography
} from "@material-ui/core";
import { trackPromise } from "react-promise-tracker";
import { SnackbarProps } from "../../../../@types/snackbarAPI.types";
import { EMPLOYEE_CLASS } from "../../../../constants/employeeClass";
import { PAY_FREQUENCY_V3 } from "../../../../constants/payFrequency";

const mailformat = /^[a-zA-Z0-9.!#$%&'+/=?^_{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/;
interface PaycheckConfig {
	pay_frequency: string;
	rate_type: string[];
	hourly_multiplication: string | number;
}

const GroupForm = () => {
	const navigate = useNavigate();
	const { setDashboardHeader } = useContext(UIContext);
	const { user } = useContext(AuthContext);
	const [assignedGroups, setAssignedGroups] = useState([]);
	const [openPaycheckDialog, setOpenPaycheckDialog] = useState(false);
	const [paycheckConfigs, setPaycheckConfigs] = useState<PaycheckConfig[]>([]);
	const [claimEngine, setClaimEngine] = useState<string[]>([]);
	const [paycheckConfig, setPaycheckConfig] = useState<PaycheckConfig>({
		pay_frequency: "",
		rate_type: [],
		hourly_multiplication: ""
	});
	const [formData, setFormData] = useState<{
		name: string;
		group_number: number | string;
		address_1: string;
		address_2: string;
		city: string;
		state: string;
		zip: string;
		country: string;
		// status: string;
		contact_number: string;
		email: string;
		claims_integration: boolean;
		// is_SSN_required?: boolean;
		employee_class: string[];
		// paycheck_config?: PaycheckConfig[];
		// buy_up_eligibility: boolean;
		claim_engine: Object[];
		SSN_provided_by_group: boolean;
	}>({
		name: "",
		group_number: "",
		address_1: "",
		address_2: "",
		city: "",
		state: "",
		zip: "",
		country: "",
		// status: "",
		contact_number: "",
		email: "",
		claims_integration: false,
		// is_SSN_required: true,
		employee_class: [],
		// paycheck_config: [],
		// buy_up_eligibility: false,
		claim_engine: [],
		SSN_provided_by_group: false
	});

	// For Edit
	const [searchParams] = useSearchParams();
	const gn = searchParams.get("gn");
	const isEditMode = Boolean(gn);
	const [editingConfigIndex, setEditingConfigIndex] = useState<number | null>(null);

	const [hasCreateClick, setHasCreateClick] = useState(false);
	const [isTestGroup, setIsTestGroup] = useState(false);
	const [snackbarAPICallProps, setSnackbarAPICallProps] = useState<SnackbarProps>({
		open: false,
		severity: undefined,
		message: "",
		handleSnackbarClose: (event, reason) => {
			if (reason === "clickaway") return;
			setSnackbarAPICallProps(
				Object.assign({}, snackbarAPICallProps, {
					open: false
				})
			);
		}
	});
	const _validation = useRef<any>({});
	const [validation, setValidation] = useState<any>({
		status: "invalid",
		group: {}
	});

	// const handleChange = (e: any) => {
	// 	const { name, value, type, checked } = e.target;
	// 	setFormData({
	// 		...formData,
	// 		[name]: type === "checkbox" ? checked : value
	// 	});
	// };
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value, type, checked } = e.target;

		// Contact number - max 10 digits
		if (name === "contact_number") {
			const digits = value.replace(/\D/g, "").slice(0, 10);
			setFormData({ ...formData, [name]: digits });
			return;
		}

		// ZIP code - max 9 digits
		if (name === "zip") {
			const digits = value.replace(/\D/g, "").slice(0, 9);
			setFormData({ ...formData, [name]: digits });
			return;
		}

		setFormData({
			...formData,
			[name]: type === "checkbox" ? checked : value
		});
	};

	const handleReturnToGroups = useCallback(
		(groupNumber: string | number) => {
			navigate(`/create-group/group-page-design?gn=${groupNumber}`);
		},
		[navigate]
	);

	const handleGroupValidation = useCallback(() => {
		const {
			name,
			group_number,
			address_1,
			address_2,
			city,
			state,
			zip,
			country,
			contact_number,
			email,
			claim_engine,
			claims_integration,
			SSN_provided_by_group
			// paycheck_config
		} = formData;

		_validation.current = {
			...validation,
			group: {},
			status: "invalid"
		};

		let flag = true;

		if (!name?.trim()) {
			_validation.current.group["name"] = "Group name is required";
			flag = false;
		}

		if (typeof group_number !== "number" && !group_number?.trim()) {
			_validation.current.group["group_number"] = "Group number is required";
			flag = false;
		}

		if (!address_1?.trim()) {
			_validation.current.group["address_1"] = "Address Line 1 is required";
			flag = false;
		}

		if (paycheckConfigs && paycheckConfigs.length === 0) {
			_validation.current.group["paycheck_config"] = "Add at least one paycheck configuration";
			flag = false;
		}

		// if (!address_2?.trim()) {
		// 	_validation.current.group["address_2"] = "Address Line 2 is required";
		// 	flag = false;
		// }

		if (!city?.trim()) {
			_validation.current.group["city"] = "City is required";
			flag = false;
		}

		if (!state?.trim()) {
			_validation.current.group["state"] = "State is required";
			flag = false;
		}

		if (!zip?.trim()) {
			_validation.current.group["zip"] = "ZIP Code is required";
			flag = false;
		} else {
			const cleanZip = zip.replaceAll("-", "");
			if (cleanZip.length !== 5 && cleanZip.length !== 9) {
				_validation.current.group["zip"] = "Enter 5 or 9 digit ZIP Code";
				flag = false;
			}
		}

		if (!country?.trim()) {
			_validation.current.group["country"] = "Country is required";
			flag = false;
		}

		// if (!status?.trim()) {
		// 	_validation.current.group["status"] = "Status is required";
		// 	flag = false;
		// }

		if (!contact_number?.trim()) {
			_validation.current.group["contact_number"] = "Contact number is required";
			flag = false;
		} else if (contact_number.length !== 10) {
			_validation.current.group["contact_number"] = "Enter valid 10 digit phone number";
			flag = false;
		}

		if (!email?.trim()) {
			_validation.current.group["email"] = "Email is required";
			flag = false;
		} else {
			// const mailformat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (!email.match(mailformat)) {
				_validation.current.group["email"] = "Enter a valid email address";
				flag = false;
			}
		}

		if (!formData.employee_class || formData.employee_class.length === 0) {
			_validation.current.group["employee_class"] = "Select at least one employee class";
			flag = false;
		}

		if (formData.claims_integration) {
			if (!formData.claim_engine || formData.claim_engine.length === 0) {
				_validation.current.group["claim_engine"] = "Select at least one claim engine";
				flag = false;
			}
		}

		// _validation.current["status"] = flag ? "valid" : "invalid";
		// if (!flag) alert("Please, fill all required fields!");
		_validation.current["status"] = flag ? "valid" : "invalid";
		if (!flag) {
			setValidation({ ..._validation.current });
		}

		setValidation({ ..._validation.current });
		return _validation.current["status"];
	}, [formData, validation, paycheckConfigs]);

	//without edit
	// const handleSubmit = useCallback(
	// 	async (event: React.MouseEvent<HTMLButtonElement>) => {
	// 		try {
	// 			event.preventDefault();
	// 			const validation = handleGroupValidation();
	// 			if (validation === "valid") {
	// 				// setHasCreateClick(true);

	// 				const payload = {
	// 					...formData,
	// 					zip: formData.zip.replaceAll("-", ""),
	// 					contact_number: formData.contact_number.replaceAll("-", ""),
	// 					claims_integration: !!formData.claims_integration,
	// 					paycheck_config: paycheckConfigs.map((config) => ({
	// 							pay_frequency: config.pay_frequency,
	// 							rate_type: config.rate_type,
	// 							hourly_multiplication: Number(config.hourly_multiplication)
	// 						}))
	// 				};

	// 				const response: any = await trackPromise(api.group.createGroup(payload));
	// 				// console.log("Before Response", response.group_number);

	// 				if (response) {
	// 					setHasCreateClick(true);
	// 					setFormData(Object.assign({}, response.data));

	// 					alert("Group Created Successfully!");
	// 					setSnackbarAPICallProps(
	// 						Object.assign({}, snackbarAPICallProps, {
	// 							open: true,
	// 							message: "Group created Successfully!",
	// 							severity: "success"
	// 						})
	// 					);

	// 					// setTimeout(() => {
	// 					handleReturnToGroups(response.group_number);
	// 					// }, 100);
	// 				}
	// 			}
	// 		} catch (error: any) {
	// 			setHasCreateClick(false);
	// 			alert("Group creation unsuccessful!");
	// 			throw error;
	// 		}
	// 	},
	// 	[formData, handleGroupValidation, navigate, , paycheckConfig, paycheckConfigs]
	// );

	//with edit
	const handleSubmit = useCallback(
		async (event: React.MouseEvent<HTMLButtonElement>) => {
			try {
				event.preventDefault();
				const validation = handleGroupValidation();
				if (validation === "valid") {
					const payload = {
						...formData,
						zip: formData.zip.replaceAll("-", ""),
						contact_number: formData.contact_number.replaceAll("-", ""),
						claims_integration: !!formData.claims_integration,
						paycheck_config: paycheckConfigs.map((config) => ({
							pay_frequency: config.pay_frequency,
							rate_type: config.rate_type,
							hourly_multiplication: Number(config.hourly_multiplication)
						}))
					};

					let response: any;

					if (isEditMode && gn) {
						const groupNumber = Number(gn);
						response = await trackPromise(api.group.editGroup(groupNumber, payload));
					} else {
						response = await trackPromise(api.group.createGroup(payload));
					}

					// console.log("response=====>", response);

					if (response) {
						setHasCreateClick(true);
						setFormData(Object.assign({}, response.data));

						alert(isEditMode ? "Group Updated Successfully!" : "Group Created Successfully!");
						setSnackbarAPICallProps({
							...snackbarAPICallProps,
							open: true,
							message: isEditMode ? "Group updated Successfully!" : "Group created Successfully!",
							severity: "success"
						});

						handleReturnToGroups(response[0]?.group_number || gn);
					}
				}
			} catch (error: any) {
				setHasCreateClick(false);
				alert(isEditMode ? "Group update unsuccessful!" : "Group creation unsuccessful!");
				throw error;
			}
		},
		[formData, handleGroupValidation, navigate, paycheckConfig, paycheckConfigs, searchParams, snackbarAPICallProps]
	);

	const getAssignGroups = useCallback(async () => {
		const params = {
			user_id: user?._id
		};
		const response = await api.assignGroupsAndLocation.getAssignedGroupsAndLocations(params);

		if (response) {
			const _assignedGroups: any[] = [];
			response.groupsAndLocations.forEach((group: any) => {
				if (group.assigned_group_info) {
					_assignedGroups.push(group);
				}
			});

			setAssignedGroups(Object.assign([], _assignedGroups));
		}
	}, [user?._id]);

	const availablePayFrequencies = PAY_FREQUENCY_V3.filter(
		(freq) => !paycheckConfigs.some((config) => config.pay_frequency === freq)
	);

	// useEffect(() => {
	// 	if (isEditMode && gn) {
	// 		const groupNumber = Number(gn);
	// 		if (isNaN(groupNumber)) return;

	// 		const fetchGroupData = async () => {
	// 			const res = await trackPromise(api.group.getGroupByGroupNumber(groupNumber));
	// 			if (res) {
	// 				const { paycheck_config, ...restData } = res;
	// 				setFormData(restData);
	// 				if (res.paycheck_config && Array.isArray(res.paycheck_config)) {
	// 					const normalizedConfigs = res.paycheck_config.map((config: PaycheckConfig) => {
	// 						const isOnlyFixed =
	// 							config.rate_type.includes("FIXED") && !config.rate_type.includes("HOURLY RATE");

	// 						return {
	// 							...config,
	// 							hourly_multiplication:
	// 								isOnlyFixed &&
	// 								(!config.hourly_multiplication || Number(config.hourly_multiplication) === 0)
	// 									? 1
	// 									: config.hourly_multiplication
	// 						};
	// 					});
	// 					setPaycheckConfigs(normalizedConfigs);
	// 				}
	// 			}
	// 		};

	// 		fetchGroupData();
	// 	}
	// }, [isEditMode, gn]);

	const groupData = useCallback(async (groupNumber: number) => {
		const res: any = await trackPromise(api.group.getGroupByGroupNumber(groupNumber));
		if (res) {
			const { paycheck_config, claim_engine, buy_up_eligibility, ...restData } = res;
			// setFormData(restData);
			setFormData({
				...restData,
				claim_engine: Array.isArray(claim_engine) ? claim_engine : []
			});

			if (res.paycheck_config && Array.isArray(res.paycheck_config)) {
				const normalizedConfigs = res.paycheck_config.map((config: PaycheckConfig) => {
					const isOnlyFixed = config.rate_type.includes("FIXED") && !config.rate_type.includes("HOURLY RATE");

					return {
						...config,
						hourly_multiplication:
							isOnlyFixed && (!config.hourly_multiplication || Number(config.hourly_multiplication) === 0)
								? 1
								: config.hourly_multiplication
					};
				});
				setPaycheckConfigs(normalizedConfigs);
			}
		}
	}, []);

	useEffect(() => {
		if (isEditMode && gn) {
			const groupNumber = Number(gn);
			if (!isNaN(groupNumber)) {
				groupData(groupNumber);
			}
		}
	}, [isEditMode, gn, groupData]);

	useEffect(() => {
		setDashboardHeader(isEditMode ? ADMIN_DASHBOARD_HEADER.edit_group : ADMIN_DASHBOARD_HEADER.create_group);
		getAssignGroups();
	}, [getAssignGroups, setDashboardHeader]);

	return (
		<div className="create-group" id="create-group">
			<Suspense fallback={<div />}>
				{/* <SnackbarAPICall snackbarProps={{ open: false }} /> */}
				<SnackbarAPICall snackbarProps={snackbarAPICallProps} />
			</Suspense>

			{/* Top Action Buttons */}
			<div
				className="pf-action-button-container"
				id="pf-action-button-container"
				style={{
					display: "flex",
					flexDirection: "row",
					alignItems: "flex-end",
					justifyContent: "flex-end",
					marginBottom: "16px"
				}}
			>
				<Button
					className="button-green"
					variant="contained"
					onClick={handleSubmit}
					disabled={hasCreateClick}
					style={{
						cursor: hasCreateClick ? "not-allowed" : "pointer",
						pointerEvents: "unset",
						marginLeft: "12px"
					}}
				>
					{/* <span className="button-label-with-icon">{isEditMode ? "Update Group" : "Create Group"}</span> */}
					<span className="button-label-with-icon">Submit</span>
					<span>
						<SendIcon className="button-icon" />
					</span>
				</Button>
			</div>

			{/* Main Form */}
			<Paper className="pf-paper-container" elevation={3} variant="outlined" style={{ padding: 40 }}>
				<Grid container spacing={2}>
					{/* {Object.entries(formData).map(([key, value], index) => ( */}
					{Object.entries(formData)
						.filter(([key]) => !["employee_class", "claim_engine"].includes(key))
						.map(([key, value], index) => (
							<Grid container spacing={2} alignItems="center" key={index} style={{ marginBottom: 30 }}>
								<Grid item xs={12} sm={4} md={3}>
									<Typography
										variant="subtitle2"
										// className="pf-label-text required"
										className={`pf-label-text ${
											key !== "address_2" && key !== "claims_integration" ? "required" : ""
										}`}
										style={{
											textTransform: "capitalize",
											whiteSpace: "nowrap",
											color: "#424242",
											fontWeight: "bold",
											fontSize: "1rem"
										}}
									>
										{key.replace(/_/g, " ")}
									</Typography>
								</Grid>
								<Grid item xs={12} sm={8} md={6}>
									{typeof value === "boolean" ? (
										<Checkbox
											name={key}
											checked={value}
											onChange={handleChange}
											sx={{
												color: "#4caf50",
												"&.Mui-checked": {
													color: "#4caf50"
												}
											}}
										/>
									) : (
										// <TextField
										// 	name={key}
										// 	placeholder={`Enter ${key.replace(/_/g, " ")}`}
										// 	value={value}
										// 	onChange={handleChange}
										// 	variant="outlined"
										// 	size="medium"
										// 	fullWidth
										// 	style={{ width: "350px" }}
										// 	type={key === "contact_number" ? "number" : "text"}
										// 	inputProps={{
										// 		maxLength: 10,
										// 		step: "1",
										// 		min: 0
										// 	}}
										// 	// error={!!validation?.group?.[key]}
										// 	helperText={validation?.group?.[key] || ""}
										// />
										<TextField
											name={key}
											placeholder={`Enter ${key.replace(/_/g, " ")}`}
											value={value}
											onChange={handleChange}
											variant="outlined"
											fullWidth
											type="text"
											style={{ width: "350px" }}
											inputProps={{
												inputMode:
													key === "zip" || key === "contact_number" ? "numeric" : "text",
												maxLength: key === "zip" ? 9 : key === "contact_number" ? 10 : undefined
											}}
											helperText={validation?.group?.[key] || ""}
										/>
									)}
								</Grid>
							</Grid>
						))}

					{/* Claims Integration Section */}
					{/* {formData.claims_integration && (
						<Grid container spacing={2} alignItems="center" style={{ marginBottom: 30 }}>
							<Grid item xs={12} sm={4} md={3}>
								<Typography
									variant="subtitle2"
									className="pf-label-text required"
									style={{
										textTransform: "capitalize",
										whiteSpace: "nowrap",
										color: "#424242",
										fontWeight: "bold",
										fontSize: "1rem"
									}}
								>
									Claims Engine
								</Typography>
							</Grid>
							<Grid item xs={12} sm={8} md={6}>
								<FormControl
									fullWidth
									style={{ width: "350px" }}
									error={!!validation?.group?.claim_engine}
								>
									<Select
										multiple
										displayEmpty
										value={formData.claim_engine}
										onChange={(e) =>
											setFormData((prev) => ({
												...prev,
												claim_engine: e.target.value as string[]
											}))
										}
										renderValue={(selected) => {
											if ((selected as string[]).length === 0) {
												return <span style={{ color: "#9e9e9e" }}>Select claim engine</span>;
											}
											return (selected as string[]).join(", ");
										}}
									>
										<MenuItem disabled value="">
											<>Select claim engine</>
										</MenuItem>
										<MenuItem value="WLT">WLT</MenuItem>
									</Select>
									{validation?.group?.claim_engine && (
										<Typography variant="caption" color="error">
											{validation.group.claim_engine}
										</Typography>
									)}
								</FormControl>
							</Grid>
						</Grid>
					)} */}
					{formData.claims_integration && (
						<Grid container spacing={2} alignItems="center" style={{ marginBottom: 30 }}>
							<Grid item xs={12} sm={4} md={3}>
								<Typography
									variant="subtitle2"
									className="pf-label-text required"
									style={{
										textTransform: "capitalize",
										whiteSpace: "nowrap",
										color: "#424242",
										fontWeight: "bold",
										fontSize: "1rem"
									}}
								>
									Claims Engine
								</Typography>
							</Grid>
							<Grid item xs={12} sm={8} md={6}>
								<FormControl
									fullWidth
									style={{ width: "350px" }}
									error={!!validation?.group?.claim_engine}
								>
									<Select
										multiple
										displayEmpty
										value={formData.claim_engine.map((claimEngine: any) => claimEngine.engineName)}
										onChange={(e) => {
											const selectedValues = e.target.value as string[];
											setFormData((prev) => ({
												...prev,
												claim_engine: selectedValues.map((name) => ({
													engineName: name
													// engineAddress: ""
												}))
											}));
										}}
										renderValue={(selected) => {
											if ((selected as string[]).length === 0) {
												return <span style={{ color: "#9e9e9e" }}>Select claim engine</span>;
											}
											return (selected as string[]).join(", ");
										}}
									>
										<MenuItem disabled value="">
											<>Select claim engine</>
										</MenuItem>
										<MenuItem value="WLT">WLT</MenuItem>
										{/* <MenuItem value="EFD">EFD</MenuItem>
										<MenuItem value="XYZ">XYZ</MenuItem> */}
									</Select>
									{validation?.group?.claim_engine && (
										<Typography variant="caption" color="error">
											{validation.group.claim_engine}
										</Typography>
									)}
								</FormControl>
							</Grid>
						</Grid>
					)}

					<Grid container spacing={2} style={{ marginBottom: 30 }}>
						<Grid item xs={12} sm={4} md={3}>
							<Typography
								variant="subtitle2"
								className="pf-label-text required"
								style={{
									textTransform: "capitalize",
									whiteSpace: "nowrap",
									color: "#424242",
									fontWeight: "bold",
									fontSize: "1rem"
								}}
							>
								Employee Class
							</Typography>
						</Grid>
						<Grid item xs={12} sm={8} md={6}>
							{Object.values(EMPLOYEE_CLASS).map((type) => (
								<div key={type}>
									<Checkbox
										checked={formData.employee_class.includes(type)}
										onChange={() => {
											const updated = formData.employee_class.includes(type)
												? formData.employee_class.filter((item) => item !== type)
												: [...formData.employee_class, type];
											setFormData({ ...formData, employee_class: updated });
										}}
										sx={{
											color: "#4caf50",
											"&.Mui-checked": {
												color: "#4caf50"
											}
										}}
									/>
									{type.replaceAll("_", " ").replace(/\b\w/g, (types) => types.toUpperCase())}
								</div>
							))}
							{validation?.group?.employee_class && (
								<Typography variant="caption" color="error">
									{validation.group.employee_class}
								</Typography>
							)}
						</Grid>
					</Grid>

					<Button
						variant="outlined"
						color="primary"
						className="required"
						onClick={() => {
							setPaycheckConfig((prev) => {
								const lastConfig = paycheckConfigs[paycheckConfigs.length - 1];
								return lastConfig
									? {
											pay_frequency: "",
											rate_type: [...lastConfig.rate_type],
											hourly_multiplication: ""
									  }
									: {
											pay_frequency: "",
											rate_type: [],
											hourly_multiplication: ""
									  };
							});

							setOpenPaycheckDialog(true);
						}}
						style={{ marginBottom: "16px" }}
					>
						+ Add Paycheck Config
					</Button>
					{validation?.group?.paycheck_config && (
						<Typography variant="caption" color="error">
							{validation.group.paycheck_config}
						</Typography>
					)}

					<Grid item xs={12}>
						<Typography variant="subtitle2" style={{ marginTop: "16px" }}>
							Added Configs:
						</Typography>
						{paycheckConfigs.length === 0 ? (
							<Typography variant="body2">No configs added yet.</Typography>
						) : (
							paycheckConfigs.map((config: any, index: any) => (
								<Box
									key={index}
									style={{
										border: "1px solid #ccc",
										padding: 8,
										marginTop: 8,
										position: "relative",
										width: "100%",
										maxWidth: "700px"
									}}
								>
									<strong>Frequency:</strong> {config.pay_frequency} <br />
									<strong>Rate Types:</strong> {config.rate_type.join(", ")} <br />
									{/* <strong>Hourly Mult:</strong> {config.hourly_multiplication} */}
									{config.rate_type.includes("HOURLY RATE") && (
										<>
											<strong>Hourly Mult:</strong> {config.hourly_multiplication}
										</>
									)}
									<IconButton
										size="small"
										style={{ position: "absolute", top: 4, right: 32 }}
										onClick={() => {
											setEditingConfigIndex(index);
											setPaycheckConfig(config);
											setOpenPaycheckDialog(true);
										}}
									>
										<EditIcon fontSize="small" />
									</IconButton>
									<IconButton
										size="small"
										style={{ position: "absolute", top: 4, right: 4 }}
										onClick={() => {
											setPaycheckConfigs((prev) => prev.filter((_, i) => i !== index));
										}}
									>
										<CloseIcon fontSize="small" />
									</IconButton>
								</Box>
							))
						)}
					</Grid>
				</Grid>
			</Paper>

			{/* Bottom Action Buttons */}
			<div
				style={{
					display: "flex",
					justifyContent: "flex-end",
					alignItems: "center",
					marginTop: "24px"
				}}
			>
				<Button
					className="button-green"
					variant="contained"
					onClick={handleSubmit}
					disabled={hasCreateClick}
					style={{
						cursor: hasCreateClick ? "not-allowed" : "pointer",
						pointerEvents: "unset",
						marginLeft: "12px"
					}}
				>
					{/* <span className="button-label-with-icon">{isEditMode ? "Update Group" : "Create Group"}</span> */}
					<span className="button-label-with-icon">Submit</span>
					<span>
						<SendIcon className="button-icon" />
					</span>
				</Button>
			</div>

			{/* Paycheck Config Dialog */}
			<Dialog
				open={openPaycheckDialog}
				onClose={() => {
					setOpenPaycheckDialog(false);
					setEditingConfigIndex(null);
				}}
				maxWidth="sm"
				fullWidth
			>
				{/* <DialogTitle>Paycheck Configuration</DialogTitle> */}
				<DialogTitle style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
					<span>Paycheck Configuration</span>
					<IconButton
						aria-label="close"
						onClick={() => setOpenPaycheckDialog(false)}
						size="small"
						sx={{
							position: "absolute",
							right: 8,
							top: 8
						}}
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>

				<DialogContent>
					<Grid container spacing={2} style={{ marginTop: 8 }}>
						<Grid item xs={12}>
							<TextField
								select
								fullWidth
								label="Pay Frequency"
								value={paycheckConfig.pay_frequency}
								onChange={(e) =>
									setPaycheckConfig({ ...paycheckConfig, pay_frequency: e.target.value })
								}
								variant="outlined"
							>
								{availablePayFrequencies.map((freq) => (
									<MenuItem key={freq} value={freq}>
										{freq.charAt(0).toUpperCase() + freq.slice(1).toLowerCase()}
									</MenuItem>
								))}
							</TextField>
						</Grid>

						<Grid item xs={12}>
							<Typography variant="subtitle1" gutterBottom>
								Rate Types
							</Typography>
							{["HOURLY RATE", "FIXED", "NOT APPLICABLE"].map((type) => (
								<div key={type}>
									<Checkbox
										checked={paycheckConfig.rate_type.includes(type)}
										// onChange={() => {
										// 	let updatedRateTypes = [...paycheckConfig.rate_type];

										// 	if (updatedRateTypes.includes(type)) {
										// 		updatedRateTypes = updatedRateTypes.filter((item) => item !== type);
										// 	} else {
										// 		updatedRateTypes.push(type);
										// 	}

										// 	const updatedConfig = {
										// 		...paycheckConfig,
										// 		rate_type: updatedRateTypes
										// 	};

										// 	// If HOURLY RATE is unchecked, clear hourly_multiplication
										// 	if (!updatedRateTypes.includes("HOURLY RATE")) {
										// 		updatedConfig.hourly_multiplication = "";
										// 	}

										// 	setPaycheckConfig(updatedConfig);
										// }}
										onChange={() => {
											let updatedRateTypes = [...paycheckConfig.rate_type];

											if (updatedRateTypes.includes(type)) {
												updatedRateTypes = updatedRateTypes.filter((item) => item !== type);
											} else {
												updatedRateTypes.push(type);
											}

											let updatedHourlyMultiplication = paycheckConfig.hourly_multiplication;

											// Logic to auto-set hourly_multiplication based on rate_type
											if (
												updatedRateTypes.includes("FIXED") &&
												!updatedRateTypes.includes("HOURLY RATE")
											) {
												updatedHourlyMultiplication = 1;
											} else if (!updatedRateTypes.includes("HOURLY RATE")) {
												updatedHourlyMultiplication = "";
											}

											setPaycheckConfig({
												...paycheckConfig,
												rate_type: updatedRateTypes,
												hourly_multiplication: updatedHourlyMultiplication
											});
										}}
										sx={{
											color: "#4caf50",
											"&.Mui-checked": {
												color: "#4caf50"
											}
										}}
									/>
									{type}
								</div>
							))}
						</Grid>

						{paycheckConfig.rate_type.includes("HOURLY RATE") && (
							<Grid item xs={12}>
								<TextField
									label="Hourly Multiplication"
									type="number"
									fullWidth
									value={paycheckConfig.hourly_multiplication}
									onChange={(e) =>
										setPaycheckConfig({
											...paycheckConfig,
											hourly_multiplication: e.target.value
										})
									}
								/>
							</Grid>
						)}

						<Grid item xs={12}>
							<Typography variant="subtitle2" style={{ marginTop: "16px" }}>
								Added Configs:
							</Typography>
							{paycheckConfigs.length === 0 ? (
								<Typography variant="body2">No configs added yet.</Typography>
							) : (
								paycheckConfigs.map((config, index) => (
									<Box
										key={index}
										style={{
											border: "1px solid #ccc",
											padding: 8,
											marginTop: 8,
											position: "relative"
										}}
									>
										<IconButton
											size="small"
											onClick={() => {
												const updatedConfigs = paycheckConfigs.filter((_, i) => i !== index);
												setPaycheckConfigs(updatedConfigs);
											}}
											sx={{
												position: "absolute",
												top: 4,
												right: 4
											}}
											aria-label="delete"
										>
											<CloseIcon fontSize="small" />
										</IconButton>
										<strong>Frequency:</strong> {config.pay_frequency} <br />
										<strong>Rate Types:</strong> {config.rate_type.join(", ")} <br />
										{/* <strong>Hourly Mult:</strong> {config.hourly_multiplication} */}
										{config.rate_type.includes("HOURLY RATE") && (
											<>
												<strong>Hourly Mult:</strong> {config.hourly_multiplication}
											</>
										)}
									</Box>
								))
							)}
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setOpenPaycheckDialog(false)} color="secondary">
						Cancel
					</Button>
					<Button
						variant="contained"
						className="button-green"
						onClick={() => {
							if (
								paycheckConfig.pay_frequency &&
								paycheckConfig.rate_type.length > 0 &&
								(!paycheckConfig.rate_type.includes("HOURLY RATE") ||
									Number(paycheckConfig.hourly_multiplication) > 0)
							) {
								const isOnlyFixed =
									paycheckConfig.rate_type.includes("FIXED") &&
									!paycheckConfig.rate_type.includes("HOURLY RATE");

								const normalizedConfig = {
									...paycheckConfig,
									hourly_multiplication: isOnlyFixed ? 1 : paycheckConfig.hourly_multiplication
								};

								if (editingConfigIndex !== null) {
									setPaycheckConfigs((prev) => {
										const updated = [...prev];
										updated[editingConfigIndex] = normalizedConfig;
										return updated;
									});
								} else {
									setPaycheckConfigs((prev) => [...prev, normalizedConfig]);
								}

								setPaycheckConfig({ pay_frequency: "", rate_type: [], hourly_multiplication: "" });
								setEditingConfigIndex(null);
								setOpenPaycheckDialog(false);
							} else {
								alert("Please fill all paycheck config fields before saving.");
							}
						}}
					>
						{editingConfigIndex !== null ? "Update" : "Save"}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default GroupForm;
